import axios from '@/api/axios';

/**
 * Retrieve list of restaurants
 * @param {number} limit - max count of projects
 * @param {number} offset - offset for pagination
 * @param {number} latitude - latitude coord for filtering by distance
 * @param {number} longitude - longitude coord for filtering by distance
 * @param {String} ordering - rule for sorting on backend
 * @returns {Promise}
 */
function listRestaurants({
  limit = 100, offset = 0, filters: { latitude, longitude }, ordering = 'name',
}) {
  const params = { limit, offset, ordering };

  if (latitude && longitude) {
    params.latitude = latitude;
    params.longitude = longitude;
    params.ordering = 'distance';
  }

  return axios.get('restaurants/', { params });
}

/**
 * Get the user data for account.
 * @returns {*}
 */
function userData() {
  return axios.get('profile/');
}

/**
 * Create the user account with data.
 * @param user
 */
function createUser(createdUser) {
  return axios.post('profile/', createdUser);
}

/**
 * Update the user account data.
 * @param updatedUser
 */
function updateUser(updatedUser) {
  return axios.patch('profile/', updatedUser);
}

export default {
  listRestaurants,
  userData,
  updateUser,
  createUser,
};



// WEBPACK FOOTER //
// ./src/apps/desktop/api/index.js